<template>
  <div class="flex items-center">
    <IconWarning class="text-static-danger-hi mr-12" />
    <span class="body-1">
      {{ i18n(translations.label) }}
    </span>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { IconWarning } from '@ds/icons/IconWarning'

import translations from './StatusRejected.translations'

const i18n = useI18n()
</script>
